import {
  Box,
  Button,
  Grid,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Layout from "../../assets/Layout";
import CandidateJobSidebar from "./CandidateJobSidebar";
import CandidateCard from "../../assets/cards/CandidateCard";

export default function EmployerCandidates() {
  const [selectedOption, setSelectedOption] = useState("");
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {};

  const DaysAgo = (date) => {
    if (date) {
      const inputDate = new Date(date);
      const currentDate = new Date();
      const timeDifference = currentDate.getTime() - inputDate.getTime();
      const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      return daysAgo;
    }
  };

  return (
    <>
      <Layout>
        <Grid container mt={8}>
          <Grid item xs={12} md={3}>
            <Button
              className="text2Mid"
              sx={{
                py: 0.5,
                px: 2,
                mx: 1,
                backgroundColor: "#F7FAFF",
                borderRadius: "0.5rem",
                color: "#2544EE",
                border: "1px solid #2544EE",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: "#2544EE",
                },
              }}
              startIcon={<ArrowBackIosIcon />}
              variant="contained"
            >
              Go Back
            </Button>
          </Grid>
          <Grid item xs={12} md={9} px={3} sx={{ textAlign: "left" }}>
            <Typography className="heading1bold" variant="h5">
              Candidates
            </Typography>
          </Grid>
        </Grid>
        <Box>
          <Grid container>
            <Grid item xs={12} md={3}>
              <CandidateJobSidebar setLoading={setLoading} setJobs={setJobs} />
            </Grid>
            <Grid item xs={12} md={9}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  my: 4,
                  borderRadius: "10px",
                  mx: 2,
                }}
              >
                <Typography
                  variant="body2"
                  className="tex2Bold"
                  sx={{ fontWeight: "bold", width: "100%", mx: 2 }}
                >
                  Showing 2,150 Candidates
                </Typography>
                <Typography
                  variant="body2"
                  className="tex2Bold"
                  sx={{
                    fontWeight: "bold",
                    width: "100%",
                    mx: 2,
                    textAlign: "end",
                  }}
                >
                  Sort By
                </Typography>
                <select
                  style={{ marginLeft: "1rem", backgroundColor: "#D9E3F6" }}
                  className="profile-skills-box text2Light"
                  value={selectedOption}
                  onChange={handleChange}
                >
                  <option disabled value="">
                    Sort by date
                  </option>
                  <option value="option1">Option 1</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </select>

                <select
                  style={{ marginLeft: "1rem", backgroundColor: "#D9E3F6" }}
                  className="profile-skills-box text2Light"
                >
                  <option disabled value="">
                    Show 10
                  </option>
                  <option value="option1">Option 1</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </select>
              </Box>

              <Grid container spacing={6} mb={10} px={5}>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
                <Grid item md={6}>
                  <CandidateCard />
                </Grid>
              </Grid>
            <Stack spacing={2} sx={{alignItems:'center'}}>
              <Pagination count={10} color="primary" />
            </Stack>
            </Grid>

          </Grid>
        </Box>
      </Layout>
    </>
  );
}
